import './style/index.less';
import SwitchCorpDialog from './SwitchCorpDialog';

export default SwitchCorpDialog;
